
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import Home from './Pages/Home'
import AboutUs from'./Pages/AboutUs'
import Founder from'./Pages/Founder'
import OurVision from'./Pages/OurVision' 
import Infrastructure from'./Pages/Infrastructure'
import Accreditation from'./Pages/Accreditation'
import Academics from'./Pages/Academics'
import Examination from'./Pages/Examination'
import Studies from'./Pages/Studies'
import Prospectus from'./Pages/Prospectus'
import FeeSchedule from'./Pages/FeeSchedule'
 import FeeStructure from'./Pages/FeeStructure'
import SchoolCalendar from'./Pages/SchoolCalendar'
import Timings from'./Pages/Timings'
import Uniform from'./Pages/Uniform'
import Circular from'./Pages/Circular'
import GeneralRule from'./Pages/GeneralRule'
import Discipline from'./Pages/Discipline'
import VideoGallery from'./Pages/VideoGallery'
import Fee from'./Pages/Fee'
import Leave from'./Pages/Leave'
import Library from'./Pages/Library'
 import Laboratory from'./Pages/Laboratory'
import RecommendationParents from'./Pages/RecommendationParents'
import Promotion from'./Pages/Promotion'
import Curriculum from'./Pages/Curriculum'
 import Criteria from'./Pages/Criteria'
import ISCcriteria from'./Pages/ISCcriteria' 
import ISCToppers from'./Pages/ISCToppers'
import ICSECriteria from'./Pages/ICSECriteria'
import ISCresult from'./Pages/ISCresult' 
import ICSEToppers from'./Pages/ICSEToppers'
import ICSEresult from'./Pages/ICSEresult'
import ManagerMessage from'./Pages/ManagerMessage'
import PrincipalMessage from'./Pages/PrincipalMessage'
import VicePrincipal from'./Pages/VicePrincipal'
import HeadMistress from'./Pages/HeadMistress'
import Alumni from'./Pages/Alumni'
import ContactUs from'./Pages/ContactUs'
import Career from'./Pages/Career'
import Events from'./Pages/Events'
import News from'./Pages/News'
import Gallery from'./Pages/Gallery'
import ErpSoftware from'./Pages/ErpSoftware'
import Pphelp from'./Pages/Pphelp' 
import SubGallery from'./Pages/SubGallery' 
import StudentCouncil from'./Pages/StudentCouncil' 
import Tc from'./Pages/Tc'
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Founder" element={<Founder />} />
          <Route path="/OurVision" element={<OurVision />} /> 
          <Route path="/Accreditation" element={<Accreditation />} />
          <Route path="/Infrastructure" element={<Infrastructure />} />
          <Route path="/Academics" element={<Academics />} />
          <Route path="/Examination" element={<Examination />} />
          <Route path="/Studies" element={<Studies />} />
          <Route path="/Prospectus" element={<Prospectus />} />
          <Route path="/FeeSchedule" element={<FeeSchedule />} />
          <Route path="/FeeStructure" element={<FeeStructure />} />
          <Route path="/SchoolCalendar" element={<SchoolCalendar />} />
          <Route path="/Timings" element={<Timings />} />
          <Route path="/Uniform" element={<Uniform />} />
          <Route path="/Circular" element={<Circular />} />
          <Route path="/GeneralRule" element={<GeneralRule />} />
          <Route path="/VideoGallery" element={<VideoGallery />} />
           <Route path="/Fee" element={<Fee />} />
           <Route path="/Leave" element={<Leave />} />
            <Route path="/Library" element={<Library />} />
            <Route path="/Laboratory" element={<Laboratory />} />
            <Route path="/RecommendationParents" element={<RecommendationParents />} />
            <Route path="/Discipline" element={<Discipline />} />
             <Route path="/Promotion" element={<Promotion />} />
           <Route path="/Curriculum" element={<Curriculum />} />
            <Route path="/Criteria" element={<Criteria />} />
          <Route path="/ISCcriteria" element={<ISCcriteria />} /> 
          <Route path="/ISCToppers" element={<ISCToppers />} />
          <Route path="/ISCresult" element={<ISCresult />} />
           <Route path="/ICSECriteria" element={<ICSECriteria />} /> 
          <Route path="/ICSEToppers" element={<ICSEToppers />} />
          <Route path="/ICSEresult" element={<ICSEresult />} /> 
          <Route path="/ManagerMessage" element={<ManagerMessage />} />
          <Route path="/PrincipalMessage" element={<PrincipalMessage />} />
          <Route path="/HeadMistress" element={<HeadMistress />} />
          <Route path="/Alumni" element={<Alumni />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/VicePrincipal" element={<VicePrincipal />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Career" element={<Career />} />
          <Route path="/News" element={<News />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/ErpSoftware" element={<ErpSoftware />} />
          <Route path="/Pphelp" element={<Pphelp />} /> 
           <Route path="/SubGallery" element={<SubGallery />} /> 
          <Route path="/StudentCouncil" element={<StudentCouncil />} /> 
           <Route path="/Tc" element={<Tc />} /> 
        </Routes> 
      </BrowserRouter>
    </>
  )
}

export default App;
